import React from "react";
import { Col, Row } from "react-bootstrap";

const KlausurenButtons = ({ setView }) => {
  
  return (
    <>
      <div className="p-3">
        <h4>Gutachten</h4>
        <Row>
          <Col>
            <button
              className="btn btn-outline-dark"
              onClick={() => setView("formNew")}
            >
              Neues Gutachten anlegen
            </button>
          </Col>
          <Col>
            <button
              className="btn btn-outline-dark"
              onClick={() => setView("openInput")}
            >
              Projektdatei öffnen
            </button>
          </Col>

        </Row>
      </div>

    </>
  );
};
export default KlausurenButtons;
